import { Children } from 'react';
import styles from './AccordionDetails.module.scss';
import className from 'classnames/bind';
import { RichText } from '@/components';

let cx = className.bind(styles);

export function AccordionDetails({ className, children, accordionSettings }) {
	const { id, isOpen, openItem } = accordionSettings;
	const classNameArray = className?.split(' ') || [];

	return (
		<div id={`accoridon-details-${id}`} className={cx(['ns_accordion-details', 'accordion-details', ...classNameArray])} aria-labelledby={`accoridon-button-${id}`} hidden={isOpen || openItem?.id === `${id}` ? false : true}>
			<div>{children}</div>
		</div>
	);
}
